// extracted by mini-css-extract-plugin
module.exports = {"hero_backdrop":"styles-module--hero_backdrop--33RnI","portfolio_img":"styles-module--portfolio_img--HmSZz"};